import { DateTime } from "luxon"

import { FragmentType, graphql, useFragment } from "@/gql"

import { MetadataSectionContainer } from "./MetadataSectionContainer"
import { PersonalDetailCard } from "./PersonalDetailCard"

const ProfessionalAssociationSectionFragment = graphql(`
  fragment ProfessionalAssociationSection on Creative {
    id
    associationMemberships {
      edges {
        node {
          id
          memberSince
          creative {
            id
            handle
          }
          association {
            id
            name
            avatar80w: avatarUrl(width: 80)
          }
        }
      }
    }
  }
`)

interface Props {
  creative: FragmentType<typeof ProfessionalAssociationSectionFragment> | null | undefined
}

export const ProfessionalAssociationSection: React.FC<Props> = props => {
  const creative = useFragment(ProfessionalAssociationSectionFragment, props.creative)

  return (
    <MetadataSectionContainer title="Guilds & Unions">
      <div className="flex flex-col gap-2">
        {creative?.associationMemberships?.edges?.map(edge => {
          const node = edge?.node
          const formattedDate = node ? DateTime.fromISO(node?.memberSince).toFormat("MMMM yyyy") : ""
          const handle = node?.creative?.handle

          return (
            <div key={node?.id} className="flex flex-row items-center gap-3">
              <PersonalDetailCard
                link={`/${handle}`}
                name={node?.association?.name}
                avatar80w={node?.association?.avatar80w}
                subtext={`Member since ${formattedDate}`}
                avatarInitials={node?.association?.name?.substring(0, 2)}
              />
            </div>
          )
        })}
      </div>
    </MetadataSectionContainer>
  )
}
